import React from 'react';
import { connectToJSContext } from '../utils.jsx';
import SectionHeader from '../section_header/index.jsx';
import { emailPatternValidation } from '../helpers';
import classNames from 'classnames';

const imgUrl =
    'https://hsl-pnw-downloadable-files.s3.amazonaws.com/1504/df211e8ed86b492b9ed21b409bd832d0-width-400.jpg';

class EmailSubscription extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            isChecked: false,
            isSubmitPressed: false,
            isSubmitSuccessful: false,
            isValid: false,
            isSubmiting: false,
            isRequestFinished: false
        };
    }

    validateEmailField = (e) => {
        const email = e.target.value;
        const isValid = emailPatternValidation(email);

        this.setState(() => ({
            email,
            isValid
        }));
    }

    handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        this.setState(() => ({
            isChecked
        }));
    }

    handleSubmit = (e) => {
        const { isValid, isChecked } = this.state;

        this.setState(() => ({
            isSubmitPressed: true,
            isRequestFinished: false
        }));

        e.preventDefault();

        if (isValid && isChecked) {
            this.setState(() => ({
                isSubmiting: true
            }));

            const request = new XMLHttpRequest();
            const url = 'https://9crfaa42nb.execute-api.us-west-2.amazonaws.com/prod/sendmail';
            const postData = {
                toAddress: this.state.email,
                templateNameHtml: 'subscribeEmailTemplate.html',
                templateNameText: 'subscribeEmailTemplate.html',
                subject: 'Buying your first home can feel simpler if you break it down',
                templateData: {}
            };
            request.onload = () => {
                const isSuccess = request.status >= 200 && request.status < 300;

                this.setState(() => ({
                    isSubmitSuccessful: isSuccess,
                    isSubmiting: false,
                    isRequestFinished: true
                }));
            };
            request.onerror = () => {
                this.setState(() => ({
                    isSubmitSuccessful: false,
                    isSubmiting: false,
                    isRequestFinished: true
                }));
            };
            request.open('POST', url, true);
            request.setRequestHeader('Access-Control-Allow-Origin', '*');
            request.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
            request.send(JSON.stringify(postData));
        }
    }

    render () {
        return (
            <div className="c-email-subscription">
                <SectionHeader
                    title="First time buyer?"
                />
                <div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xs-12 col-md-6 c-email-subscription__image-wrapper">
                                <div style={{
                                    backgroundImage: `url('${imgUrl}')`,
                                    backgroundSize: "cover",
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'right',
                                    height: '330px'
                                }}
                                />
                            </div>
                            <div className="col-xs-12 col-md-6 c-email-subscription__form">
                                <form noValidate onSubmit={this.handleSubmit} className="hs-contact">
                                    <p className="c-email-subscription__intro_text">
                                        No two journeys to buy a home look exactly the same.
                                        But knowing the key steps – and having some tips, tools, and a team to guide
                                        you – can help.
                                    </p>
                                    <p className="c-email-subscription__intro_text">
                                        In our 6 weeks long educational email series, You will receive one email per
                                        week full of useful tips and tools to help you follow the path
                                        to your first home.
                                    </p>
                                    <div>
                                        <div className="c-email-subscription__email-title">E-mail address</div>
                                        <input
                                            type="email"
                                            name="email-address"
                                            id="email-address"
                                            placeholder="email@example.com"
                                            disabled={this.state.isSubmiting}
                                            className={
                                                classNames(
                                                    'form-control',
                                                    { 'validation-error': !this.state.isValid &&
                                                        this.state.isSubmitPressed
                                                    }
                                                )
                                            }
                                            onChange={this.validateEmailField}
                                            onBlur={this.validateEmailField}
                                        />
                                        <span className={classNames(
                                            'error-text',
                                            { 'hidden': !this.state.isSubmitPressed || this.state.isValid }
                                        )}
                                        >
                                            This seems to be an invalid email address.
                                        </span>
                                    </div>
                                    <div className="c-email-subscription__email_agreement">
                                        <label className="cb-container">
                                            <p className="c-email-subscription__agreement_text">
                                                You agree to subscribe to receive emails from Wells Fargo
                                                Home Mortgage. You can opt out of these subscription-based
                                                messages at any time.
                                            </p>
                                            <input
                                                type="checkbox"
                                                name="email-agreement"
                                                id="email-agreement"
                                                disabled={this.state.isSubmiting}
                                                onChange={this.handleCheckboxChange}
                                            />
                                            <span
                                                className={classNames(
                                                    'cb-checkmark',
                                                    { 'cb-error': !this.state.isChecked && this.state.isSubmitPressed }
                                                )}
                                            />
                                        </label>
                                        <div className={classNames(
                                            'error-text',
                                            { 'hidden': !this.state.isSubmitPressed || this.state.isChecked }
                                        )}
                                        >
                                            Please check the box to subscribe.
                                        </div>
                                    </div>
                                    <div className="c-email-subscription__submit_btn_wrapper">
                                        <button
                                            className="c-email-subscription__submit_btn btn"
                                            disabled={this.state.isSubmiting}
                                        >
                                            { this.state.isSubmiting ? 'Sending...' : 'Sign up for the email series' }
                                        </button>
                                    </div>
                                    <div className={classNames(
                                        'c-email-subscription__thank_you',
                                        {
                                            'hidden': !this.state.isSubmitSuccessful || !this.state.isRequestFinished
                                        }
                                    )}
                                    >
                                        We received your subscription opt-in, thank you!
                                    </div>
                                    <div className={classNames(
                                        'c-email-subscription__thank_you',
                                        {
                                            'hidden': this.state.isSubmitSuccessful || !this.state.isRequestFinished
                                        }
                                    )}
                                    >
                                        Something went wrong. Please try again!
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = () => ({});

export default connectToJSContext(mapStateToProps)(EmailSubscription);



// WEBPACK FOOTER //
// ./components/email_subscription/index.jsx